import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Offer } from '@/models/Offer'

export default new CachedResourceStore<Offer>(Offer, {
	namespaced: true
})
